import gql from 'graphql-tag';

export const PlanOverview = gql`
    query PlanOverview($childIds: [ChildId!]!, $siteId: SiteId!, $view: View!, $selectedPlanId: PlanId) {
        finance {
            invoiceSummary {
                v1 {
                    overview {
                        planOverviewV2(
                            childIds: $childIds
                            siteId: $siteId
                            view: $view
                            selectedPlanId: $selectedPlanId
                        ) {
                            plans {
                                id
                                timeframe
                                dateRange {
                                    from
                                    to
                                }
                                lastBilledDate
                                billingState
                                isSelected
                                ... on InvoiceSummaryPlanV2 {
                                    tuitionName
                                    billingFrequency
                                    total
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
